__turbopack_context__.v({
  "className": "inter_2f89d0ef-module__rb3_qa__className",
});
